export default __webpack_public_path__ + "static/media/arrangeRanks.67320a03.svg";